export default __webpack_public_path__ + "static/media/etc04.11c18682.png";